import { eInternalOrderStatus } from '../../../ui-toolkit/enums/eInternalOrderStatus';

const orderStatusIsNotLateStageOrArchived = (orderStatus?: eInternalOrderStatus | null) =>
  !orderStatus ||
  ![
    eInternalOrderStatus.signing_occurred,
    eInternalOrderStatus.waiting_for_funds,
    eInternalOrderStatus.ready_to_disburse,
    eInternalOrderStatus.funded,
    eInternalOrderStatus.recorded,
    eInternalOrderStatus.funded_and_recorded,
    eInternalOrderStatus.policy_issued,
    eInternalOrderStatus.complete,
    eInternalOrderStatus.cancelled,
    eInternalOrderStatus.post_closing,
  ].includes(orderStatus);

export default orderStatusIsNotLateStageOrArchived;
